module.exports = __webpack_public_path__ + "static/media/agent-man.f5673bd7.png";